import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, FolderKanban, LibraryBig, ClipboardList, Target, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const navItems = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/projects", label: "Consulting Projects", icon: FolderKanban, testid: "nav-projects" },
  { to: "/worksheets", label: "Worksheets", icon: ClipboardList, testid: "nav-worksheets" },
  { to: "/templates", label: "Framework Templates", icon: LibraryBig, testid: "nav-templates" },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="flex h-screen bg-slate-50 overflow-hidden">
      <aside className="w-64 bg-slate-900 text-white flex-shrink-0 hidden md:flex flex-col border-r border-slate-800">
        <div
          className="h-16 flex items-center gap-2 px-5 border-b border-slate-800 cursor-pointer"
          onClick={() => navigate("/dashboard")}
        >
          <div className="h-8 w-8 rounded-md bg-emerald-500 flex items-center justify-center">
            <Target className="h-5 w-5 text-white" />
          </div>
          <span className="font-display font-bold text-lg">Performance Flow Pro</span>
        </div>

        <nav className="flex-1 p-3 space-y-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={item.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-emerald-500 text-white"
                    : "text-slate-300 hover:bg-slate-800 hover:text-white"
                }`
              }
            >
              <item.icon className="h-5 w-5" />
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="p-3 border-t border-slate-800">
          <div className="flex items-center gap-3 px-2 py-2">
            <img
              src={user?.picture || "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=80&q=80"}
              alt=""
              className="h-9 w-9 rounded-full object-cover border border-slate-700"
            />
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium truncate">{user?.name}</p>
              <p className="text-xs text-slate-400 truncate">{user?.email}</p>
            </div>
            <button
              data-testid="logout-btn"
              onClick={logout}
              className="text-slate-400 hover:text-white transition-colors"
              title="Sign out"
            >
              <LogOut className="h-4 w-4" />
            </button>
          </div>
        </div>
      </aside>

      <main className="flex-1 flex flex-col overflow-hidden relative">{children}</main>
    </div>
  );
}
